import { api } from "lib";

export const getReportTableHistory = async (params = {}) => {
    return await api.post("/v1/reportEmployee/searchEmployeeRegistrationReportPaging", params);
};
export const ExportEmployeeRegistrationReportPaging = async (params = {}) => {
    return await api.post("/v1/reportEmployee/exportEmployeeRegistrationReportPaging", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};
export const ExportEmployeeWarningLetterPaging = async (params = {}) => {
    return await api.post("/v1/reportEmployee/exportWarningLetterReport", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};
export const getReportWarningLetter = async (params = {}) => {
    return await api.post("/v1/reportEmployee/searchWarningLetterReport", params);
};
export const ExportQuotaLeaveReportReportPaging = async (params = {}) => {
    return await api.post("/v1/reportEmployee/exportQuotaLeaveReportPaging", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};
export const getReportTableLeaveRights = async (params = {}) => {
    return await api.post("/v1/reportEmployee/searchQuotaLeaveReportPaging", params);
};
export const ExportWorkingTimeGroupReportPaging = async (params = {}) => {
    return await api.post("/v1/reportEmployee/exportWorkingTimeGroupReportPaging", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};
export const ExportCreateTxnReportProcessing = async (params = {}) => {
    return await api.post("/v1/reportProcessing/createTxnReportProcessing", { ...params, timeout: 99999999 });
};
export const ExportAbsenceReport = async (params = {}) => {
    return await api.post("/v1/reportEmployee/exportAbsenceReport", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};
export const ExportAbsenceReportDetail = async (params = {}) => {
    return await api.post("/v1/reportEmployee/exportAbsenceReportAdept", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const ExportExpense = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportExpense", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};
export const ExportExpenseSummary = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportExpenseSummary", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const ExportcheckTxnReportProcessing = async (params = {}) => {
    return await api.post("/v1/reportProcessing/checkTxnReportProcessing", { ...params, timeout: 99999999 });
};

export const getReportTableWorkingTime = async (params = {}) => {
    return await api.post("/v1/reportEmployee/searchWorkingTimeGroupReportPaging", params);
};
export const getSearchAbsenceReport = async (params = {}) => {
    return await api.post("/v1/reportEmployee/searchAbsenceReport", params);
};
export const getMyExpenseRequestCompanyPagination = async (params = {}) => {
    return await api.post("/v1/expense/getMyExpenseRequestCompanyPagination", params);
};
export const getReportTableWorkingTimeCustomer = async (params = {}) => {
    return await api.post("/v1/reportEmployee/searchEmployeeWorkingTimeGroupReportPaging", params);
};

export const getReportTableSalary = async (params = {}) => {
    return await api.post("/v1/reportEmployee/searchWorkingTimeGroupReportPaging", params); //ยังไม่ใช่เส้นนี้ หลังบ้านยังไม่ส่งมา
};

export const getPosition = async (params = {}) => {
    return await api.post("/v1/position/getPosition", params);
};

export const getDepartmentOptions = async (params = {}) => {
    return await api.post("/v1/dropdown/getStmDepartment", params);
};

export const getDropdownDepartmentByRoleHr = async (params = {}) => {
    return await api.post("/v1/reportDropdown/roleDropdownForEmployeeHistoryReport", params);
};
export const getWorkInLocation = async (params) => {
    return await api.post("/v1/dropdown/getBranch", params);
};

export const ExportLeaveRightsReportByEmployee = async (params = {}) => {
    return await api.post("/v1/reportEmployee/exportQuotaLeaveReportByEmployee", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const getLeaveTypeOptions = async (params) => {
    return await api.post("/v1/dropdown/getLeaveTypeByCompany", params);
}

export const getEmployeeEarningReport = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/searchEmployeeEarningRecordReportPaging", params);
}

export const getPeriodOptions = async (params) => {
    return await api.post("/v1/dropdown/getPayrollPeriods", params);
}

export const ExportEmployeeEarningRecordReportExcel = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportEmployeeEarningRecordReportExcel", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const ExportEmployeeEarningRecordReportExcelPlus = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportEmployeeEarningRecordReportExcelPlus", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const ExportEmployeeEarningRecordReportPdf = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportEmployeeEarningRecordReportPdf", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const getOvertimeReport = async (params = {}) => {
    return await api.post("/v1/reportEmployee/searchEmployeeOvertimeReport", params);
}

export const ExportOvertimeReportExcel = async (params = {}) => {
    return await api.post("/v1/reportEmployee/exportEmployeeOvertimeReport", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const getSection50BisReport = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/searchSection50BisReportPaging", params);
}
export const getSearchSection50ExtraBisReportPaging = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/searchSection50ExtraBisReportPaging", params);
}

export const ExportSection50BisReportPdf = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportThawi50", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const sendEmailThawi50 = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/sendEmailThawi50", { ...params, timeout: 99999999 });
};
export const sendEmailThawi50All = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/sendEmailThawi50All", { ...params, timeout: 99999999 });
};

export const ExportSection50BisReportPdfExtra = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportThawi50Extra", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const sendEmailThawi50Extra = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/sendEmailThawi50Extra", { ...params, timeout: 99999999 });
};
export const sendEmailThawi50AllExtra = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/sendEmailThawi50AllExtra", { ...params, timeout: 99999999 });
};

export const ExportPND1ReportDocumentPdf = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportPnd1Document", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const ExportPND1ReportPdf = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportPnd1", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const ExportPND1ReportTxt = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportTextPnd1", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const ExportPND1ReportZip = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportTextPnd1ZipAll", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const ExportPND1KorReportDocumentPdf = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportPnd1KDocument", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const ExportPND1KorReportPdf = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportPnd1K", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};
export const exportPND1KorReportExcel = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportPnd1KExcel", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const ExportPND1KorReportTxt = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportTextPnd1k", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const ExportPND1KorReportZip = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportPnd1KZipAll", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const ExportWorkingTimeGroupReportPagingeByEmp = async (params = {}) => {
    return await api.post("/v1/reportEmployee/exportEmployeeWorkingTime", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const ExportTimeAttendanceReport = async (params = {}) => {
    return await api.post("/v1/reportEmployee/exportTimeAttendanceReport", params, { responseType: "blob", timeout: 0 });
};

export const ExportPND3ReportPdf = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportPnd3", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const ExportPND3ReportDocumentPdf = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportPnd3Document", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const ExportPND3ReportZip = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportPnd3ZipAll", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const ExportSSOResignationPdf = async (params = {}) => {
    return await api.post("/v1/reportEmployee/exportEmployeeSSOResignationReport", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const PreviewAnnualPND1Report = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportSummaryPND1PerYearReportPdf", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const ExportAnnualPND1Report = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportSummaryPND1PerYearReport", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};
export const PreviewAnnualPND3Report = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportSummaryPND3PerYearReportPdf", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const ExportAnnualPND3Report = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportSummaryPND3PerYearReport", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};
export const getPositionDropdownList = async (params = {}) => {
    return await api.post("/v1/reportDropdown/positionDropdownByRoleHr", params);
};

export const getSSOPayrollReport = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/searchSocialSecurityMonthEndReport", params);
}

export const ExportSSOPayrollReport = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportSocialSecurityMonthEndReport", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const getEmployeeUnderLabourTableReport = async (params = {}) => {
    return await api.post("/v1/reportEmployee/searchEmployeeRegistrationReportByEmployeeRole", params);
}

export const ExportEmployeeUnderLabourReport = async (params = {}) => {
    return await api.post("/v1/reportEmployee/exportSearchEmployeeRegistrationReportByEmployeeRole", { ...params, timeout: 99999999 }, { responseType: 'blob' });
};

export const getBranch = async (params = {}) => {
    return await api.post("/v1/dropdown/getBranch", params);
};

export const getFundReportPagination = async (params = {}) => {
    return await api.post("/v1/funds/getFundReportPagination", params);
};

export const getFundNameOptions = async (params = {}) => {
    return await api.post("/v1/funds/getFundNameDropdown", params);
};

export const exportFundReport = async (params = {}) => {
    return await api.post("/v1/payrollCalculation/exportFundReport", params, { responseType: 'blob', timeout: 120000, });
};